export type { AccessTokenGetResponse, CardActivateResponse } from '@extend-services/virtual-cards'
import type { WalletGetResponse } from '@extend-services/virtual-cards'

export type VirtualCardRemainingValue = WalletGetResponse['remainingValue']
